import { Navigate, Outlet } from "react-router-dom";

interface PrivateRouteProps {
  isLoggedIn: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ isLoggedIn }) => {
  // If not logged in, redirect to landing page
  if (!isLoggedIn) {
    return <Navigate to="/" />;
  }

  // If logged in, allow access to private route
  return <Outlet />;
};

export default PrivateRoute;